import React, { Component } from "react";
import axios from "axios";
import { getAuthHttpHeaders } from "../auth";

import CandleSticksPanel from "../charts/CandleSticksPanel";
import { Loader } from "semantic-ui-react";

class BotStatsCandles extends Component {
  state = {
    loading: false,
    closedTrades: null,
    botInstanceId: null,
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.botInstance.id !== prevState.botInstanceId) {
      return {
        closedTrades: null,
        botInstanceId: nextProps.botInstance.id,
      };
    }

    return null;
  }

  async load(botInstanceId) {
    this.setState({ loading: true });

    try {
      let axiosRequest = axios.create({
        baseURL: "api",
        timeout: 30 * 1000,
        headers: {
          Accept: "application/json",
          ...getAuthHttpHeaders(),
        },
      });

      let response = await axiosRequest.get(`botInstance/${botInstanceId}/closedTrades`);

      this.setState({ closedTrades: response.data });
    } catch (e) {
      this.setState({ closedTrades: null });
    } finally {
      this.setState({ loading: false });
    }
  }

  render() {
    let candles = null;
    if (this.state.closedTrades !== null) {
      candles = (
        <CandleSticksPanel
          key={this.props.botInstance.id}
          config={this.props.botInstance.config}
          botInstanceId={this.props.botInstance.id}
          exchangeType={this.props.botInstance.exchangeType}
          trades={this.state.closedTrades}
        />
      );
    } else if (!this.state.loading) {
      setTimeout(() => {
        this.load(this.props.botInstance.id);
      });
    }

    return (
      <div>
        <Loader active={this.state.loading} />
        {candles}
      </div>
    );
  }
}

export default BotStatsCandles;



// WEBPACK FOOTER //
// ./src/bot/BotStatsCandles.js